export default __webpack_public_path__ + "static/media/expand.ade06b4f.svg";